/** Gallery figure parallax zoom on scroll. */
(function () {
  document.querySelectorAll('[data-zm-gallery-figure]').forEach((fig) => {
    const img = fig.querySelector('img');
    if (!img) return;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          fig.classList.toggle('is-zoomed', entry.isIntersecting);
        });
      },
      { threshold: 0.2 }
    );
    io.observe(fig);
  });
})();
